<template>
  <q-dialog v-if="display">
    <template v-slot:title>
      Key
    </template>
    <template v-slot:body>
      <table class="table mb--0">
        <thead>
          <tr>
            <th class="thead">Key</th>
            <th class="thead">Description</th>
          </tr>
        </thead>
        <tr>
          <td class="tdata" width="20">
            <span class="node__example bg--info"></span>
          </td>
          <td class="tdata">Risk severity unselected</td>
        </tr>
        <tr>
          <td class="tdata" width="20">
            <span class="node__example bg--success"></span>
          </td>
          <td class="tdata">Risk severity set to low</td>
        </tr>
        <tr>
          <td class="tdata" width="20">
            <span class="node__example bg--warning"></span>
          </td>
          <td class="tdata">Risk severity set to medium</td>
        </tr>
        <tr>
          <td class="tdata" width="20">
            <span class="node__example bg--danger"></span>
          </td>
          <td class="tdata">Risk severity set to high</td>
        </tr>
        <tr>
          <td class="tdata" width="20">
            <span class="conn__example conn__example--solid"></span>
          </td>
          <td class="tdata">Connection type: Inclusive</td>
        </tr>
        <tr>
          <td class="tdata" width="20">
            <span class="conn__example conn__example--dotted"></span>
          </td>
          <td class="tdata">Connection type: Exclusive</td>
        </tr>
      </table>

      <table class="table mb--4">
        <tr>
          <td class="tdata" width="100">
            <img src="@/assets/start.png" />
          </td>
          <td class="tdata">Start Node</td>
        </tr>
        <tr>
          <td class="tdata" width="100">
            <img src="@/assets/finish.png" />
          </td>
          <td class="tdata">Finish Node</td>
        </tr>
      </table>
    </template>
    <template v-slot:actions>
      <q-button title="Close" @click="cancel" variant="primary" />
    </template>
  </q-dialog>
</template>

<script>
import { editor } from "../js/editor.js";

export default {
  mixins: [editor],
  props: {
    display: Boolean,
    nodeItem: Number
  },
  data() {
    return {
      node: this.nodeItem
    };
  },
  methods: {
    cancel() {
      this.$root.$emit("closeDialog");
    }
  }
};
</script>
